import { render, staticRenderFns } from "./MediaFactoryTabs.vue?vue&type=template&id=b05826ec&scoped=true&"
import script from "./MediaFactoryTabs.vue?vue&type=script&lang=js&"
export * from "./MediaFactoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./MediaFactoryTabs.vue?vue&type=style&index=0&id=b05826ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05826ec",
  null
  
)

export default component.exports